import SiteGoogleMap from "@/app/components/lib/googlemaps/SiteGoogleMap";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useEffect } from "react";

interface Props {
  onChange: (location: google.maps.LatLngLiteral) => void;
  position: google.maps.LatLngLiteral;
  //   form: UseFormReturn<FieldValues, any>;
}

const Map: React.FC<Props> = ({ onChange, position }) => {
  const mobile = useIsMobile();
  useEffect(() => {
    setTimeout(() => onChange({ lat: 0, lng: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="w-100">
      <SiteGoogleMap
        width={"100%"}
        height={mobile ? 195 : 163}
        position={position}
        setPosition={(position) => onChange(position)}
      />
    </div>
  );
};

export default Map;
